<template>
  <div :style="{'height':height+'px'}" class="product-detail">
    <CreateNewOrder @setModalState="setModalState" @editDesignInfo="editDesignInfo"
                    :yongLiaoList="design.designDetailDTOS" :fieldData="fieldData" :designInfo="designInfoTemp"
                    :productModalshow="showDetailModal"/>
    <ChooseYongliao @searchYongLiao="searchYongLiao" @selYongLiao="selectYongLiao" :list="zhubuList"
                    :modalShow="showYongLiaoModal" ref="ChooseYongLiao"/>
    <div style="padding-bottom:50px">
      <van-sticky offset-top="30">
        <van-icon @click="back" class="back-icon" name="arrow-left"/>
      </van-sticky>
      <img class="large-img" @click="imgPreview"  :src="design.imageOne"/>
    </div>
    <div class="select-bar">
      <div @click="expandOrCollpase" class="collpase">{{ expanded ? '收起' : '展开' }}
        <van-icon :name="expanded?'arrow-down':'arrow-up'"/>
      </div>

      <div v-show="expanded" class="select-items">
        <!-- <div class="select-item">
          <van-tag style="position: absolute;" type="primary">主布</van-tag>
          <img :src="selZhuBu.src||selZhuBu.imageOne" />
           <span class="title">{{selZhuBu.title}}</span>
        </div> -->
<!--        主布组件色块图-->
        <div class="select-item" v-if="selZhuBu.productId">
          <van-tag style="position: absolute;" :type="'primary'">{{ selZhuBu.componentName }}</van-tag>
          <van-image
              @click="onSelectDesignItem(selZhuBu,'main')"
              fit="contain"
              position="center"
              class="van-img"
              :src="selZhuBu.productImageUrl ? selZhuBu.productImageUrl : ''"
          />
<!--          <img  @click="onSelectDesignItem(selZhuBu,'main')" :src="selZhuBu.productImageUrl ? selZhuBu.productImageUrl : ''"/>-->
          <span class="title">{{ selZhuBu.productNumber }}</span>
        </div>
        <div class="select-item" v-else>
          <div class="add-peibu">
            <div @click="onSelectDesignItem(selZhuBu,'main')">
              <van-icon name="plus"/>
            </div>
            请选择
          </div>
          <span class="title">{{ selZhuBu.componentName }}</span>
        </div>
<!--        配布组件色块图-->
        <div v-for="(item,index) in peibuSmallNewList">
          <div class="select-item" v-show="item.componentImageUrl" v-if="item.productId">
            <van-tag style="position: absolute;" type="warning">{{ item.componentName }}</van-tag>
            <van-image
                @click="onSelectDesignItem(item)"
                fit="contain"
                position="center"
                class="van-img"
                :src="item.productImageUrl ? item.productImageUrl : ''"
            />
<!--            <img @click="onSelectDesignItem(item)"-->
<!--                 :src="item.productImageUrl ? item.productImageUrl : ''">-->
            <span class="title">{{ item.productNumber }}</span>
          </div>
          <div class="select-item" v-show="item.componentImageUrl" v-else>
            <div class="add-peibu">
              <div @click="onSelectDesignItem(item)">
                <van-icon name="plus"/>
              </div>
              请选择
            </div>
            <span class="title">{{ item.componentName }}</span>
          </div>
        </div>
      </div>

    </div>
    <van-goods-action>
      <van-goods-action-icon style="flex: 0 0 100px;" icon="cart-o" text="前往购物车" @click="onClickIcon"/>
      <van-goods-action-button
          type="danger"
          text="加入购物车"
          :disabled="addCartDisable"
          @click="onClickButton"
      />
    </van-goods-action>
  </div>
</template>
<script>
import CreateNewOrder from '@/components/CreateNewOrder.vue';
import ChooseZhubu from '@/components/ChooseZhubu.vue';
import ChooseYongliao from '@/components/ChooseYongliao.vue';
import {ImagePreview, Toast} from 'vant';
import {fieldData} from "../dict";

export default {
  name: "DingZhiDetail",
  components: {
    CreateNewOrder,
    ChooseZhubu,
    ChooseYongliao
  },
  data() {
    return {
      peibuCofigs: [{componentName: "中拼"}, {componentName: "内拼"}],
      expanded: true,
      selZhuBu: this.$store.getters.selZhuBu || {},
      selDingZhiProduct: this.$store.getters.selProduct || {},
      selYongLiao: [],
      selYongLiaoNew: [],
      peiBuList: [],
      zhubuList: [],
      designInfoTemp: {},
      yongLiaoList: [],
      yongLiaoNewList: [],
      designInfo: {
        list: {},
        qiangkuan: 2.5,
        liangao: 2.7,
      },
      showYongLiaoModal: false,
      showDetailModal: false,
      showDingzhiModal: false,
      fieldData: [],
      height: 0,
      imgs: ['imageOne', 'imageTwo', 'imageThree', 'imageFour', 'imageFive'],
      design: {
        designDetailDTOS: []
      },
      productid: this.$route.query.productid,
      designId: this.$route.query.designId,
      designType: this.$route.query.designType,
      customerDesignId: this.$route.query.customerDesignId,
      selectDesignItem: [],
      addCartDisable: true
    };
  },
  computed: {
    zhubuSmallList() {
      let designDetailDTOS = this.design.designDetailDTOS || []
      return designDetailDTOS.filter((item, index) => index == 0)
    },
    peibuSmallList() {
      let designDetailDTOS = this.design.designDetailDTOS || []
      // return designDetailDTOS.filter((item)=>item.componentName=='配布').concat(designDetailDTOS.filter((item)=>item.componentName=='配布'))

      return designDetailDTOS.filter((item, index) => index > 0)
    },

    zhubuSmallNewList() {
      let designDetailDTOS = this.design.designDetailDTOS || []
      return designDetailDTOS.filter((item, index) => index == 0)
    },
    peibuSmallNewList() {
      let designDetailDTOS = this.design.designDetailDTOS || []
      // return designDetailDTOS.filter((item)=>item.componentName=='配布').concat(designDetailDTOS.filter((item)=>item.componentName=='配布'))

      return designDetailDTOS.filter((item, index) => index > 0)
    }
  },
  created() {

  },
  mounted() {
    this.imageOne = this.$route.query.img
    Object.entries(this.AddCartMethods).map((item1) => this[item1[0]] = item1[1].bind(this))
    const height = document.body.clientHeight;
    this.height = height;
    // this.getPeibuList();
    let _fieldData = fieldData.filter((item) => item.name != 'colorType')
    this.fieldData = _fieldData
    this.getStyleData(this.designId, this.customerDesignId).then(() => {

      this.selZhuBu = this.zhubuSmallNewList[0]
      if (this.hasSelectAll()) {
        this.getImageMerge()
      }
    })

  },
  methods: {
    selectYongLiao(item) {
      // 选择用料货号， 返回货号和色块图给组件

      this.selectDesignItem.productId = item.id
      this.selectDesignItem.productNumber = item.number
      this.selectDesignItem.productImageUrl = item.colorImageUrl || ''
      this.selectDesignItem.designType = item.designType || ''

      if (this.hasSelectAll()) {
        this.getImageMerge()
      }

    },
    hasSelectAll() {
      let allCount = 0
      let selectCount = 0
      allCount = this.design.designDetailDTOS.filter(item => item.componentImageUrl).length
      selectCount = this.design.designDetailDTOS.filter(item => item.productId && item.componentImageUrl).length
      // console.log(allCount)
      // console.log(selectCount)
      this.addCartDisable = false
      return selectCount == allCount
    },
    searchYongLiao(keyword) {

      let zhubu = this.$refs.ChooseYongLiao.zhubu
      if(zhubu == "main" && this.designType != 'LianTou') {
        // 主布 同系列货号
        this.$refs.ChooseYongLiao.productlist = this.searchYongLiaoFilter(this.design.mainProductList,keyword)
        this.$refs.ChooseYongLiao.finished = true
        return
      }

      // 帘头 或者配布 需要请求版本货号
      this.$http.post("public/productSeries", {
        componentId:this.selectDesignItem.componentId,
        searchInfo:keyword,
        designId:this.selectDesignItem.designId,
      }).then(res => {

        this.$refs.ChooseYongLiao.productlist = res || []
        this.$refs.ChooseYongLiao.finished = true

        if (this.designType != 'LianTou' && !res) {
          // 配布版本货号为空 ，那使用主配布货号
          this.$refs.ChooseYongLiao.productlist = this.searchYongLiaoFilter(this.design.allProductList,keyword)
        }
      })

    },
    searchYongLiaoFilter(list,keyword) {
      //  主配布  货号 模糊搜索
      return list.map(item => {
        let productlist = item.products.filter(vo => (vo.number.toUpperCase()).includes(keyword.toUpperCase())) || []
        if(productlist) {
          return {
            seriesName:item.item,
            products:productlist
          }
        }
      })

    },
    expandOrCollpase() {
      this.expanded = !this.expanded;
    },
    imgPreview() {
      ImagePreview([this.design.imageOne])
    },
    onSelectYongLiao(item) {
      //
      this.selYongLiaoId = item.id;
      this.showYongLiaoModal = true;
    },
    onSelectDesignItem(item,zhubu) {


      if(zhubu == "main" && this.designType != 'LianTou') {
        // 主布 同系列货号
        this.$refs.ChooseYongLiao.productlist = this.design.mainProductList
        this.selectDesignItem = item
        this.$refs.ChooseYongLiao.zhubu = zhubu || ''
        this.$refs.ChooseYongLiao.keyword = ""
        this.$refs.ChooseYongLiao.finished = true
        this.showYongLiaoModal = true
        return
      }

      // 帘头 或者配布 需要请求版本货号
      this.$http.post("public/productSeries", {
        componentId: item.componentId,
        searchInfo: '',
        designId: item.designId,
      }).then(res => {

        this.$refs.ChooseYongLiao.productlist = res || []
        if (this.designType != 'LianTou' && !res) {
          // 配布版本货号为空 ，那使用主配布货号
          this.$refs.ChooseYongLiao.productlist = this.design.allProductList
        }

        this.selectDesignItem = item // 绑定当前款式明细
        this.$refs.ChooseYongLiao.zhubu = zhubu || ''
        this.$refs.ChooseYongLiao.keyword = ""
        this.$refs.ChooseYongLiao.finished = true
        this.showYongLiaoModal = true;
      })





    },
    onClickIcon() {
      this.$router.replace('/cart?activeHeader=chuanglian')
    },

    setSelectZhubuModal(v) {
      this.showDingzhiModal = v;
    },
    selectItem($item, type = 'zhubuList') {

      this[type] = this[type].map((item) => {
        if ($item.number == item.number) {
          item.active = true
        } else {
          item.active = false
        }
        return item
      })

    },
    getImageMerge() {

      let param = this.design.designDetailDTOS.map((item) => {
        return {
          "designDetailId": item.id,
          "productId": item.productId
        }
      })
      this.$http.post("public/mergeImages", param).then(res => {
        if(res) {

          this.design.imageOne = res
          this.designInfo.imageOne = res
        }
      })
    },
    setModalState(v) {
      this.showDetailModal = v
    },

    back() {
      history.go(-1)
    },
    onDingzhi() {
      this.showDingzhiModal = true;
    },


  }
};
</script>
<style scoped>
.large-img {
  max-width: 100%;
  margin: 0 auto;
  display: block;
  max-height: 80%;
  margin-top: 0px;
}

.back-icon {
  background: #10111163;
  width: 20px;
  /* padding: 8px 0; */
  border-radius: 100%;
  text-align: center;
  color: #fff;
  font-weight: 600;
  height: 20px;
  font-size: 20px;
  line-height: 20px;
}

.select-bar {
  font-size: 14px;
  padding: 10px;
  box-sizing: border-box;
  background: #d3d3d51c;
  position: fixed;
  bottom: 50px;
  width: 100%;
}

.select-bar .collpase {
  text-align: right;
  font-size: 12px;
  color: #777;
}

.select-items {
  display: flex;
  margin-left: 10px;
  overflow-x: auto;
}

.select-item {
  margin-right: 10px;
  width: 75px;
  height: 75px;
  font-size: 12px;
  text-align: center;
  border: 1px solid #f0494e59;
  border-radius: 4px;
  background: #fff;
  padding: 2px;
  position: relative;
}

.select-item .van-icon {
  font-size: 18px;
  margin-top: 15px;
}

.select-item img,.van-img {
  width: 56px;
  height: 56px;
  margin: 0 auto;
  display: block;
  margin-top: 2px;
  object-fit: contain;
}

.select-item span {
  display: block;
  z-index: 10;
}

.add-peibu {
  color: #aaa;
  text-align: center;
  font-size: 24px;
  background: #F1f1f1;
  height: 60px;
  /* line-height: 60px; */
  font-size: 12px;
}
</style>
